import { RestSlice } from '../../../../redux/rest.slice';
import { IppDataProvider } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippDataProviderSlice = new RestSlice<IppDataProvider>(
	localizationService.getLocalizedString('ipp.industryAccount.dataProviders.pageHeading'),
	Resource.IppDataSources
);
export default ippDataProviderSlice.rests.reducer;
